import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const RoleAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/roles",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  listPermissions: async function (cancel = false) {
    const response = await api.request({
      url: "/roles/list-permissions",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  store: async function (data, cancel = false) {
    const response = await api.request({
      url: "/roles",
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  show: async function (role, cancel = false) {
    const response = await api.request({
      url: "/roles/" + role,
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  update: async function (role, data, cancel = false) {
    const response = await api.request({
      url: "/roles/" + role,
      method: "PUT",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  delete: async function (role, cancel = false) {
    const response = await api.request({
      url: "/roles/" + role,
      method: "DELETE",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },
}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(RoleAPI)